import { render, staticRenderFns } from "./ScheduleDetails.vue?vue&type=template&id=71a5b3ca&scoped=true&"
import script from "./ScheduleDetails.vue?vue&type=script&lang=js&"
export * from "./ScheduleDetails.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDetails.vue?vue&type=style&index=0&id=71a5b3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5b3ca",
  null
  
)

export default component.exports